import React from 'react';
import { useTranslation } from 'react-i18next';

import './ConsultationBox.css';

export const ConsultationBox = ({ message = '3b.performance.consultationWarning' }) => {
    const { t } = useTranslation();

    return (
        <div className="consultation-box">
            <p>{t(message)}</p>
        </div>
    );
};
